import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export function PaymentSuccess() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [state, setState] = useState("checking"); // checking | paid | error
  const [tries, setTries] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setState("error"); return; }
    let active = true;
    const poll = async (n) => {
      if (!active) return;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { await refresh(); setState("paid"); return; }
        if (n >= 8) { setState("error"); return; }
        setTries(n + 1);
        setTimeout(() => poll(n + 1), 2000);
      } catch { if (n >= 8) setState("error"); else setTimeout(() => poll(n + 1), 2000); }
    };
    poll(0);
    return () => { active = false; };
  }, [refresh]);

  return (
    <div className="min-h-screen bg-chessup-bg flex items-center justify-center p-6 grain">
      <div className="w-full max-w-md text-center rounded-2xl border border-chessup-border bg-chessup-card p-10 animate-fade-up">
        <Logo size={44} className="justify-center mb-6" />
        {state === "checking" && (<><Loader2 className="h-12 w-12 text-chessup-turq mx-auto mb-4 animate-spin" /><h1 className="font-heading text-2xl text-chessup-text">Confirmando seu pagamento...</h1><p className="text-sm text-chessup-subtext mt-2">Aguarde um instante ({tries}/8).</p></>)}
        {state === "paid" && (<><CheckCircle2 className="h-14 w-14 text-chessup-turq mx-auto mb-4" data-testid="payment-success-icon" /><h1 className="font-heading text-2xl text-chessup-text">Bem-vindo à ChessUp Academy Premium!</h1><p className="text-sm text-chessup-subtext mt-2">Seu acesso completo foi liberado.</p><button onClick={() => nav("/painel")} className="mt-6 w-full rounded-full bg-chessup-gold py-3.5 font-semibold text-chessup-deep hover:bg-chessup-goldlight">IR PARA O PAINEL</button></>)}
        {state === "error" && (<><XCircle className="h-14 w-14 text-chessup-gold mx-auto mb-4" /><h1 className="font-heading text-2xl text-chessup-text">Ainda confirmando</h1><p className="text-sm text-chessup-subtext mt-2">Se você concluiu o pagamento, o acesso será liberado em instantes. Verifique sua assinatura.</p><Link to="/assinatura" className="mt-6 inline-block w-full rounded-full bg-chessup-gold py-3.5 font-semibold text-chessup-deep hover:bg-chessup-goldlight">VER MINHA ASSINATURA</Link></>)}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-screen bg-chessup-bg flex items-center justify-center p-6 grain">
      <div className="w-full max-w-md text-center rounded-2xl border border-chessup-border bg-chessup-card p-10 animate-fade-up">
        <Logo size={44} className="justify-center mb-6" />
        <XCircle className="h-14 w-14 text-chessup-subtext mx-auto mb-4" />
        <h1 className="font-heading text-2xl text-chessup-text">Pagamento não concluído</h1>
        <p className="text-sm text-chessup-subtext mt-2">Nenhuma cobrança foi feita. Você pode tentar novamente quando quiser.</p>
        <Link to="/assinatura" className="mt-6 inline-block w-full rounded-full bg-chessup-gold py-3.5 font-semibold text-chessup-deep hover:bg-chessup-goldlight">VOLTAR PARA ASSINATURA</Link>
      </div>
    </div>
  );
}
